namespace advisorop.components.servicer {

    export class SleeveModelRecListController {
        public dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        sleevemodelsToShow: domains.SleeveModelRec[];
        sleevemodels: domains.SleeveModelRec[];
        sleevemodelsWithoutFundingSleeve: domains.SleeveModelRec[];
        public tolerance: number = 0.02;
        titleSuffix: string = "";
        useFundingSleeveInCalc: boolean = false;

        user: domains.identity.IUser;
        servicer: any;
        showFundingSleeve: boolean = false;
        showAllSleeves: boolean = false;

        isInitializing: boolean = true;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#sleeveModelRecContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Reconciling...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "identityService", "generalService", "advisoryFirmApi"];
        constructor(private servicerService: services.ServicerService,
            private identityService: services.IdentityService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.servicer = domains.SystemLoginType.SERVICER;
            let that = this;

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "SleeveModelRec"
                },
                bindingOptions: {
                    dataSource: "vm.sleevemodelsToShow"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgAdvisorsSettings"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                onCellPrepared: function (e) {
                    if (e.rowType === 'data' && e.columnIndex === 0) {
                        var textColor = 'black';
                        let row = e.data;
                        switch (row.result) {
                            case 0: {
                                textColor = '#cc0000';
                                break;
                            }
                            case 1: {
                                textColor = '#ff9999';
                                break;
                            }
                            case 2: {
                                let perecentToUse = that.useFundingSleeveInCalc ? row.actualPercentage : row.actualPercentagePrime;
                                textColor = (Math.abs(row.proposalPercentage - perecentToUse) < that.tolerance) ? 'green' : '#e600e6';
                                break;
                            }
                        }
                        e.cellElement.css("color", textColor);
                    }
                },
                columns: [
                    { dataField: 'number', caption: 'Account Number' },
                    { dataField: 'accountName', caption: 'Account Name' },
                    { dataField: 'productName', caption: 'Product Name' },
                    { dataField: 'proposalPercentage', caption: 'Proposal %', format: { type: "percent", precision: 2 } },
                    { dataField: 'actualPercentage', caption: 'Actual %', format: { type: "percent", precision: 2 }, visible: this.useFundingSleeveInCalc },
                    { dataField: 'actualPercentagePrime', caption: 'Actual %', format: { type: "percent", precision: 2 }, visible: !this.useFundingSleeveInCalc },
                    { dataField: 'modelValue', caption: 'Model Value', format: 'currency' },
                    { dataField: 'accountTotal', caption: 'Account Total', format: 'currency', visible: this.useFundingSleeveInCalc },
                    { dataField: 'accountTotalPrime', caption: 'Account Total', format: 'currency', visible: !this.useFundingSleeveInCalc },
                    { dataField: 'cash', caption: 'Cash', format: 'currency' },
                    { dataField: 'accountCash', caption: 'Account Cash', format: 'currency', visible: this.useFundingSleeveInCalc },
                    { dataField: 'accountCashPrime', caption: 'Account Cash', format: 'currency', visible: !this.useFundingSleeveInCalc },
                    {
                        calculateCellValue: function (row) {
                            switch (row.result) {
                                case 0: {
                                    return "No matching proposal";
                                }
                                case 1: {
                                    return "No matching sleeve";
                                }
                                case 2: {
                                    let perecentToUse = that.useFundingSleeveInCalc ? row.actualPercentage : row.actualPercentagePrime;
                                    if (Math.abs(row.proposalPercentage - perecentToUse) < that.tolerance) {
                                        return "Sleeve and Proposal match";
                                    }
                                    else {
                                        return "Sleeve and Proposal are not within the limit";
                                    }
                                }
                            }
                        },
                        caption: 'Result',
                        allowFiltering: true,
                        allowSorting: true,
                        allowSearch: true
                    }
                ]
            };
        }

        currentAdvisor: domains.IAdvisor;

        isServicerAdmin(): boolean {
            return (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
        }

        isSleeveWithinToleranceOfProposal(sleevemodel: domains.SleeveModelRec): boolean {
            return (Math.abs(sleevemodel.proposalPercentage - (this.useFundingSleeveInCalc ? sleevemodel.actualPercentage : sleevemodel.actualPercentagePrime)) > this.tolerance);
        }

        updateGrid(): void {
            let that = this;
            this.sleevemodelsToShow = this.showFundingSleeve ?
                this.sleevemodels.filter(s => that.showAllSleeves ? true : (s.result == 2 ? this.isSleeveWithinToleranceOfProposal(s) : true)) :
                this.sleevemodelsWithoutFundingSleeve.filter(s => that.showAllSleeves ? true : (s.result == 2 ? this.isSleeveWithinToleranceOfProposal(s) : true));
            $('#sleeveModelList').dxDataGrid("instance").columnOption(4, 'visible', this.useFundingSleeveInCalc);
            $('#sleeveModelList').dxDataGrid("instance").columnOption(5, 'visible', !this.useFundingSleeveInCalc);
            $('#sleeveModelList').dxDataGrid("instance").columnOption(7, 'visible', this.useFundingSleeveInCalc);
            $('#sleeveModelList').dxDataGrid("instance").columnOption(8, 'visible', !this.useFundingSleeveInCalc);
            $('#sleeveModelList').dxDataGrid("instance").columnOption(10, 'visible', this.useFundingSleeveInCalc);
            $('#sleeveModelList').dxDataGrid("instance").columnOption(11, 'visible', !this.useFundingSleeveInCalc);
            $('#sleeveModelList').dxDataGrid("instance").refresh();
        }

        firmChanged(): void {
            this.titleSuffix = this.selFirm.advisoryFirmName;

            this.isInitializing = true;

            this.servicerService.sleeveModelRec().then(response => {
                this.sleevemodels = response.data;
                if (this.sleevemodels.length > 0) {
                    let asOfDate = new Date('' + this.sleevemodels[0].asOfDate);
                    if (typeof (asOfDate.getFullYear) === 'function') {
                        let day = '' + asOfDate.getDate();
                        let month = '' + (asOfDate.getMonth() + 1);
                        let year = '' + asOfDate.getFullYear();
                        if (month.length < 2)
                            month = '0' + month;
                        if (day.length < 2)
                            day = '0' + day;
                        this.titleSuffix = this.sleevemodels[0].firmName + ' as of ' + [year, month, day].join('-');
                    }
                }
                this.sleevemodelsWithoutFundingSleeve = this.sleevemodels.filter(s => s.modelIdentifierInt != 174);
                this.updateGrid();
                this.isInitializing = false;
            }, err => this.isInitializing = false).catch(reason => {
                this.generalService.showError(reason);
            });
        }

        $onInit(): void {
            this.isInitializing = true;

            this.identityService.getUserPromise().then(response => {
                this.user = response;
                // THIS IS NOT OK !!!!

                if (this.user.systemLoginType == domains.SystemLoginType.ADVISOR) {
                    this.currentAdvisor = this.user.advisor;
                };
            });
            this.advisoryFirmApi.getAdvisoryFirmsLight()
                .then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

    }

    class SleeveModelRecList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                advisorId: "<",
                titleSuffix: "="
            };
            this.controller = SleeveModelRecListController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/sleeve-model-rec-list.html';
        }
    }
    angular.module(Constants.APP).component("sleeveModelRecList", new SleeveModelRecList());

}